<template>
  <div>
    <!-- Vertical Line -->
    <div class="container d-flex justify-content-center heading">
      <div class="vl"></div>
    </div>

    <!-- Main Heading -->
    <div class="container mt-5 d-flex justify-content-center heading-text col-lg-5">
      <h2 class="heading-head text-uppercase fw-bold mb-0">
        THE RIGHT LEARNING AT THE RIGHT TIME
      </h2>
    </div>

    <!-- Logo -->
    <div class="col-md-3 col-lg-2 col-6 d-flex m-auto px-5 py-5">
      <img :src="logo" class="grey-section-logo w-100 h-100" alt="AFGC Logo" />
    </div>

    <!-- Description -->
    <div class="container d-flex justify-content-center text-details">
      <p class="text-center w-70 h1size font16 mb-5">
        Air Force Global College at Air University is charged with developing Air and Space Professionals
        who are critical and creative thinkers. Using an agile and tailored
        approach to lifelong learning, the Air Force Global College presents a full menu
        of educational options. Through the spectrum of PME, the Air Force Global College
        has the right learning at the right time to take you to
        <b>your next level.</b>
      </p>
    </div>

    <!-- Faculty Stats -->
    <div class="container col-sm-12 col-md-12 p-0 d-flex align-items-end justify-content-center">
      <div class="txt-box text-light px-3 py-4">
        <p class="font18 fw-bold">
          Learn from faculty who have been there
        </p>
        <div class="row justify-content-center">
          <div
            v-for="(data, i) in partner"
            :key="i"
            class="d-flex flex-column col-12 col-md-4"
          >
            <p class="font32 fw-bold mb-0" style="color: #ffc627">
              {{ data.num }}
            </p>
            <p class="font14">{{ data.des }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Optional Video Embed (currently commented out) -->
    <!--
    <div class="width65 container-fluid d-flex justify-content-center mt-5 mb-5">
      <div class="embed-responsive embed-responsive-16by9">
        <iframe
          class="embed-responsive-item"
          src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
    -->
  </div>
</template>

<script setup>
import { ref } from 'vue'
import logo from '@/assets/images/afgc_logo.png'

const partner = ref([
  {
    num: '40%',
    des: 'of faculty have a PhD.',
  },
  {
    num: '120+',
    des: 'faculty members have command experience.',
  },
  {
    num: '12',
    des: 'faculty members are former wing commanders.',
  },
])
</script>

<style scoped lang="scss">
.heading {
  margin-top: 96px;
}

.vl {
  border-left: 3px solid gray;
  height: 62px;
}

.heading-text {
  margin-top: 20px;
}

.text-details {
  // padding-top: 32px;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.w-70 {
  width: 70%;
}
@media (max-width: 768px) {
  .w-70 {
    width: 100%;
  }
}

.font32 {
  font-size: 32px;
}
</style>
